// AUTO GENERATED FILE - Changes WILL be lost.
// es - used as 'es' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Ticket de apuestas",
  "product.last60-row-single": "NBA Last 60 Partido único",
  "product.sb-english-single": "Partido de Soccerbet Inglés",
  "product.sb-italian-single": "Partido de Soccerbet Italiano",
  "product.sb-greek-single": "Partido de Soccerbet Griego",
  "product.sb-english-league": "Partido de liga Inglesa",
  "product.sb-italian-league": "Partido de liga Italiana",
  "product.sb-greek-league": "Partido de liga Griega",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Hacer apuesta",
  "betslip.clear": "Eliminar todo",
  "betslip.clearResult": "Eliminar",
  "betslip.noSelections": "Agregue selecciones para apostar",
  "betslip.notLoggedIn": "Inicia sesión para comenzar a apostar",
  "betslip.refresh": "Actualizar",
  "betslip.totalStake": "Total Apuesta",
  "betslip.noHistoryData": "No hay información de apuesta disponible",
  "betslip.openBets": "Apuestas abiertas",
  "betslip.betHistory": "Historial de apuestas",
  "betslip.betHistoryWon": "Ganada",
  "betslip.betHistoryLost": "Perdida",
  "loading.loading": "Cargando",
  "loading.account": "Cargando cuenta",
  "loading.league": "Cargando Liga",
  "loading.gameweeks": "Cargando semanas de juego",
  "loading.markets": "Cargando mercados",
  "loading.bethistory": "Cargando historial de apuestas",
  "login.loginRequired": "Necesario iniciar sesión",
  "login.loginToBet": "Inicia sesión para comenzar a apostar",
  "navigation.back": "Volver",
  "navigation.close": "Cerrar",
  "video.liveStreamAvailable": "Transmisión en vivo disponible",
  "video.logInToWatch": "Inicia sesión para ver",
  "error.error": "Error",
  "error.404": "Página no encontrada",
  "error.gameLaunchFailed": "No se pudo iniciar el juego.",
  "error.unknownErrorCode": "Error desconocido: {code}",
  "error.minUnitStakeLimitExceeded": "La apuesta mínima es {limit}",
  "error.maxUnitStakeLimitExceeded": "La apuesta máxima es {limit}",
  "error.minTotalStakeLimitExceeded": "La apuesta total mínima es {limit}",
  "error.maxTotalStakeLimitExceeded": "La apuesta total máxima es {limit}",
  "error.stakeInvalidMultiple": "La apuesta debe ser un múltiplo de {multiple}",
  "error.notPlaced": "No apostado",
  "error.wagerDisallowed": "Apuesta no permitida",
  "error.errorEventIsOff": "El evento ha comenzado",
  "wagerType.Singles": "Sencillo",
  "wagerType.Doubles": "Dobles",
  "wagerType.Trebles": "Triples",
  "wagerType.Accumulator": "Acumulado",
  "wagerType.Perm 4-Folds": "4 - Múltiple",
  "wagerType.Perm 5-Folds": "5 - Múltiple",
  "wagerType.Perm 6-Folds": "6 - Múltiple",
  "wagerType.Perm 7-Folds": "7 - Múltiple",
  "wagerType.Perm 8-Folds": "8 - Múltiple",
  "wagerType.Perm 9-Folds": "9 - Múltiple",
  "error.excess_bets": "Máximo de {limit} apuestas simultáneas en el ticket de apuesta; favor ajustar.",
  "product.sb-turkish-league": "Liga Turka de Soccerbet",
  "error.minBetslipLimitExceeded": "El mínimo total en el ticket de apuesta es {limit}",
  "error.maxBetslipLimitExceeded": "El máximo total en el ticket de apuesta es {limit}",
  "error.exceededMaxPayout": "El monto máximo a pagar es de {limit}; favor reducir su apuesta.",
  "betslip.potentialReturns": "Posible retorno",
  "betslip.taxDisclaimer": "Todas sus ganancias netas se gravan en el momento de la liquidación de la apuesta. El importe del impuesto se calculará en función de la ganancia potencial de la apuesta.",
  "error.maintenanceEnabled": "El servidor está actualmente en mantenimiento.",
  "error.internalError": "Error Interno",
  "error.invalidSession": "La sesión no es válida",
  "error.accountDisabled": "La cuenta está desactivada",
  "error.invalidPlayerID": "ID de jugador no válida",
  "error.insufficientBalance": "Saldo insuficiente",
  "error.configError": "Error de configuración",
  "error.betPlaceFailed": "Apuesta fallida",
  "error.invalidProductID": "ID de producto no válida",
  "error.playerReachedGamingLimits": "Cliente ha alcanzado los límites de juego responsable",
  "error.gameCycleDoesNotExist": "El ciclo del juego no existe",
  "error.betAmountLimitExceeded": "Se ha superado el límite de ganancias potenciales para clientes no verificados",
  "betslip.netStake": "Apuesta Neta",
  "betslip.tax": "Impuesto",
  "error.badReturns": "Rendimientos potenciales son inferiores a la apuesta bruta",
  "betslip.taxDisclaimerPoland": "Ganancias se reducirán un 10% para importes superiores a 2.280 PLN.",
  "error.incompatibleVersion": "Versión de la aplicación no compatible. Por favor, actualice.",
  "product.iihf-row-single": "Campeonato Mundial de la IIHF",
  "iihf.fixture.pending": "{home} V. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Volver al jugador",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "El RTP medio de este juego es de {limit}.",
  "error.betslipContainsInvalidOptions": "El talón de apuestas contiene opciones no válidas en rojo",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "No más apuestas",
  "playtime": "Tiempo de juego",
  "gameId": "ID de juego",
  "noGames": "No hay partidos disponibles. Revise pronto",
  "Home": "Local",
  "Away": "Visita",
  "Visitor": "Visitante",
  "rules": "Reglas",
  "soccerbet.gameWeek": "PARTIDOS DE LA SEMANA",
  "soccerbet.noGameWeeks": "No hay semanas de juego disponibles. Vuelva a consultar pronto.",
  "soccerbet.league": "TABLA DE LIGA",
  "soccerbet.table.name": "Equipo",
  "soccerbet.table.won": "V",
  "soccerbet.table.drawn": "E",
  "soccerbet.table.lost": "D",
  "soccerbet.table.points": "PT",
  "abbr.event.Both Teams To Score": "AEA",
  "event.Both Teams To Score": "Ambos anotan",
  "event.Over / Under": "Más/Menos de",
  "event.Double Chance": "Doble oportunidad",
  "event.Match Result": "Resultado del partido",
  "event.Exact Goals": "Goles exactos",
  "event.Correct Score": "Resultado correcto",
  "event.Match Result Both Score": "Resultado del partido y ambos anotan",
  "event.Result Und/Over 1.5 Total Goals": "Resultado del partido y Más/Menos de 1.5 goles",
  "event.Result Und/Over 2.5 Total Goals": "Resultado del partido y Más/Menos de 2.5 goles",
  "event.Under Over 1.5 Total Goals": "Más/Menos de 1.5 goles en total",
  "event.Under Over 2.5 Total Goals": "Más/Menos de 2.5 goles en total",
  "event.Under Over 3.5 Total Goals": "Más/Menos de 3.5 goles en total",
  "event.Under Over 4.5 Total Goals": "Más/Menos de 4.5 goles en total",
  "event.Total Goals 1 To 2": "Total de goles 1 a 2",
  "event.Total Goals 1 To 3": "Total de goles 1 a 3",
  "event.Total Goals 1 To 4": "Total de goles 1 a 4",
  "event.Total Goals 2 To 3": "Total de goles 2 a 3",
  "event.Total Goals 2 To 4": "Total de goles 2 a 4",
  "event.Under Over 1.5 Home Goals": "Más/Menos de 1.5 goles del local",
  "event.Under Over 1.5 Away Goals": "Más/Menos de 1.5 goles del visitante",
  "event.Home Team Exact Goals": "Goles exactos equipo local",
  "event.Away Team Exact Goals": "Goles exactos equipo visitante",
  "selection.Yes": "Si",
  "selection.No": "No",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Si",
  "selection.1+No": "1+No",
  "selection.X+Yes": "X+Si",
  "selection.X+No": "X+No",
  "selection.2+Yes": "2+Si",
  "selection.2+No": "2+No",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "Me",
  "selection.O": "Ma",
  "selection.1+O": "1+Ma",
  "selection.X+O": "X+Ma",
  "selection.2+O": "2+Ma",
  "selection.1+U": "1+Me",
  "selection.X+U": "X+Me",
  "selection.2+U": "2+Me",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1X",
  "selection.TID_DRAW_OR_AWAY_WIN": "X2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "MÁS DE",
  "selection.Under": "MENOS DE",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GIA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLM",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İST BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "BES",
  "abbr.sb-turkish.team.FEN": "FEN",
  "abbr.sb-turkish.team.GAL": "GAL",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GEN",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "BUR",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "IBA",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "GAZ",
  "abbr.sb-turkish.team.GOZ": "GOZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "CRS",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "abbr.sb-english.team.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham F.",
  "abbr.sb-english.team.NOT": "NOT",
  "iihf-row.team.CAN": "Canadá",
  "iihf-row.team.FIN": "Finlandia",
  "iihf-row.team.RUS": "Rusia",
  "iihf-row.team.USA": "Estados Unidos",
  "iihf-row.team.CZE": "Chequia",
  "iihf-row.team.SWE": "Suecia",
  "iihf-row.team.SVK": "Eslovaquia",
  "iihf-row.team.NOR": "Noruega",
  "iihf-row.team.DEN": "Dinamarca",
  "abbr.iihf-row.team.CAN": "CAN",
  "abbr.iihf-row.team.FIN": "FIN",
  "abbr.iihf-row.team.RUS": "RUS",
  "abbr.iihf-row.team.USA": "EE.UU.",
  "abbr.iihf-row.team.CZE": "CZE",
  "abbr.iihf-row.team.SWE": "SWE",
  "abbr.iihf-row.team.SVK": "SVK",
  "abbr.iihf-row.team.NOR": "NOR",
  "abbr.iihf-row.team.DEN": "DIN",
  "event.Icematchresnt": "Resultado del Partido (1X2) (TR)",
  "event.Icematchresot": "Resultado del Partido (1,2) (INCL. OT)",
  "event.Icebothteamstoscore": "Ambos Equipos Marcarán (TR)",
  "event.Icecorrectscoreot": "Resultado Correcto (INCL. OT)",
  "event.Iceexactgoalsot": "Goles Exactos (INCL. OT)",
  "event.Icegamelines2nt": "Hándicap 2-way (TR)",
  "event.Icegamelines3nt": "Hándicap 3-way (TR)",
  "event.Iceou2p5totalgoalsot": "Más de 2.5 Goles (INCL. OT)",
  "event.Iceou3p5totalgoalsot": "Más de 3.5 Goles (INCL. OT)",
  "event.Iceou4p5totalgoalsot": "Más de 4.5 Goles (INCL. OT)",
  "event.Iceteamaexactgoalsot": "Goles Exactos del Equipo Local (INCL. OT)",
  "event.Iceteambexactgoalsot": "Goles Exactos del Equipo Visitante (INCL. OT)",
  "event.Icematchresou3p5totalgoalsnt": "Resultado del Partido y +/- de 3.5 Goles (TR)",
  "event.Icematchresou3p5totalgoalsot": "Resultado del Partido y +/- de 3.5 Goles (INCL. OT)",
  "event.Icehighestscoreperiodnt": "Líneas del Período Más Goleador (TR)",
  "event.Iceou25goalsteamateambot": "Más de/Menos de 2.5 Goles del Equipo Local o Visitante (INCL. OT)",
  "event.Icefirstteamtoscore": "¿Qué Equipo Marcará Primero? (INCL. OT)",
  "event.Iceteamtowinmostperiods": "Equipo que Gana Más Periodos (TR)",
  "selection.A": "{home}",
  "selection.B": "{away}",
  "selection.A -3.5": "{home} -3.5",
  "selection.A -3.0": "{home} -3.0",
  "selection.A -2.5": "{home} -2.5",
  "selection.A -2.0": "{home} -2.0",
  "selection.A -1.5": "{home} -1.5",
  "selection.A -1.0": "{home} -1.0",
  "selection.A +1.0": "{home} +1.0",
  "selection.A +1.5": "{home} +1.5",
  "selection.A +2.0": "{home} +2.0",
  "selection.A +2.5": "{home} +2.5",
  "selection.A +3.0": "{home} +3.0",
  "selection.A +3.5": "{home} +3.5",
  "selection.B -3.5": "{away} -3.5",
  "selection.B -3.0": "{away} -3.0",
  "selection.B -2.5": "{away} -2.5",
  "selection.B -2.0": "{away} -2.0",
  "selection.B -1.5": "{away} -1.5",
  "selection.B -1.0": "{away} -1.0",
  "selection.B +1.0": "{away} +1.0",
  "selection.B +1.5": "{away} +1.5",
  "selection.B +2.0": "{away} +2.0",
  "selection.B +2.5": "{away} +2.5",
  "selection.B +3.0": "{away} +3.0",
  "selection.B +3.5": "{away} +3.5",
  "selection.X -3.0": "X -3.0",
  "selection.X -2.0": "X -2.0",
  "selection.X -1.0": "X -1.0",
  "selection.X +1.0": "X +1.0",
  "selection.X +2.0": "X +2.0",
  "selection.X +3.0": "X +3.0",
  "selection.A & Over": "{home} & Más de",
  "selection.A & Under": "{home} & Menos de",
  "selection.X & Over": "X y Más de",
  "selection.X & Under": "X y Menos de",
  "selection.B & Over": "{away} y Más de",
  "selection.B & Under": "{away} y Menos de",
  "selection.A Over": "{home} Más de",
  "selection.A Under": "{home} Menos de",
  "selection.B Over": "{away} Más de",
  "selection.B Under": "{away} Menos de"
}
